__turbopack_context__.v({
  "className": "caveat_57eff8dc-module__pFoqda__className",
});
